import { render, staticRenderFns } from "./ProductsPreOrder.vue?vue&type=template&id=3c133a2d&scoped=true&"
import script from "./ProductsPreOrder.vue?vue&type=script&lang=js&"
export * from "./ProductsPreOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPreOrder.vue?vue&type=style&index=0&id=3c133a2d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c133a2d",
  null
  
)

export default component.exports